import React from 'react';
import PropTypes from 'prop-types';
import {useTransilluminatorTooltipControls} from './TransilluminatorTooltip.utils';
import {ControlButtons, ControlTooltip} from '../../ControlTooltip';


export function TransilluminatorTooltip(props) {
  const [controlItems, setControlItems] = React.useState([]);

  const {getControlItems} = useTransilluminatorTooltipControls();

  const tooltipStyle = () => {
   let style = {top: '0px', left: '50%', transform: 'translateX(-50%)'};
   if(!props.showControls){
     style.top = '35px';
   }
   if (props.open) {
     style.top = '-90px';
   }
   return style;
 };

  React.useEffect(() => {
    setControlItems(getControlItems(props));
  }, [props.illuminated, props.open, props.containsGel]);

  return (
    <ControlTooltip
      label='Transilluminator'
      showControls={props.showControls}
      tooltipStyle={tooltipStyle()}>
      <ControlButtons buttonList={controlItems} />
    </ControlTooltip>
  );
}

TransilluminatorTooltip.propTypes = {
  /**
   * Booolean to set if contols tooltip should be displayed
   */
  showControls: PropTypes.bool,

  /**
   * Boolean to specify if lid Open
   */
  open: PropTypes.bool,
  illuminated: PropTypes.bool,
  containsGel: PropTypes.bool,
  /**
   * Function to invoke on Clicking config menu
   */
  openShowTransilluminatorControlsModal: PropTypes.func,
  /**
   * Function to open/close Lid
   */
  toggleLid: PropTypes.func,
  /**
   * Funciton to eject all tubes
   */
  onEjectGel: PropTypes.func,
};

TransilluminatorTooltip.defaultProps = {
  showControls: false,
};
